import { useEffect, useState } from "react";
import { api, brl } from "@/lib/api";
import { Clock, MessageCircle } from "lucide-react";
import { Link } from "react-router-dom";

const fmt = (d) => (d ? d.split("-").reverse().join("/") : "");
const waUrl = (phone, text) => {
  const d = (phone || "").replace(/\D/g, "");
  if (!d) return null;
  const num = d.length >= 12 ? d : `55${d}`;
  return `https://wa.me/${num}?text=${encodeURIComponent(text)}`;
};

export function DueTodayCard() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/finance/receivables-today").then(({ data }) => setRows(data)).catch(() => {}); }, []);
  if (!rows.length) return null;
  const total = rows.reduce((s, r) => s + (r.amount || 0), 0);
  return (
    <div data-testid="due-today-card" className="rounded-2xl border border-amber-700/60 bg-amber-950/20 p-4 space-y-3">
      <div className="flex items-center justify-between gap-2 flex-wrap">
        <div className="flex items-center gap-2 font-mono-caps text-xs text-amber-300 uppercase tracking-widest">
          <Clock className="h-4 w-4" /> Parcelas a receber hoje
        </div>
        <div data-testid="due-today-total" className="font-display text-lg font-black text-amber-200 tabular-nums">{brl(total)}</div>
      </div>
      <ul className="space-y-2">
        {rows.slice(0, 6).map((r) => {
          const text = `Olá ${r.customer_name || ""}, passando para lembrar da parcela de ${brl(r.amount)} ${r.overdue ? `vencida em ${fmt(r.due_date)}` : "que vence hoje"}. Pode confirmar o pagamento?`;
          const wa = waUrl(r.customer_phone, text);
          return (
            <li key={r.id} data-testid={`due-today-${r.id}`} className="flex items-center justify-between gap-2 rounded-xl border border-amber-900/50 bg-zinc-950/60 p-2.5">
              <div className="min-w-0">
                <div className="text-sm font-bold text-zinc-100 truncate">{r.customer_name || "Sem cliente"}</div>
                <div className="text-[11px] text-zinc-400 truncate">
                  {r.link ? <Link to={r.link} className="hover:text-amber-200">{r.description}</Link> : r.description}
                  {r.overdue && <span className="ml-1.5 text-red-300">· atrasada {fmt(r.due_date)}</span>}
                </div>
              </div>
              <div className="flex items-center gap-2 shrink-0">
                <span className="font-display text-sm font-black tabular-nums text-amber-100">{brl(r.amount)}</span>
                {wa && (
                  <a data-testid={`due-today-wa-${r.id}`} href={wa} target="_blank" rel="noopener noreferrer"
                     className="inline-flex items-center justify-center h-8 w-8 rounded-md bg-emerald-600 hover:bg-emerald-500 text-white">
                    <MessageCircle className="h-4 w-4" />
                  </a>
                )}
              </div>
            </li>
          );
        })}
      </ul>
      {rows.length > 6 && <div className="text-[11px] text-amber-200">+ {rows.length - 6} parcela(s). <Link to="/owner/financeiro" className="underline">Abrir Financeiro</Link></div>}
    </div>
  );
}
